import http from '@/http/axios_init'

// 连接成功后进行绑定
export function bindSuccess(data) {
	return http({
		method: 'POST',
		url: 'Pioneer/bind',
		data
	})
}
// 消息列表
export function queryMsgList(data) {
	return http({
		method: 'POST',
		url: 'Pioneer/messagList',
		data
	})
}
// 消息 - 已读状态
export function queryMsgRead(data) {
	return http({
		method: 'POST',
		url: 'Pioneer/branchYue',
		data
	})
}
// 公告详情
export function queryNoticeDetail(data) {
	return http({
		method: 'POST',
		url: 'DcOa/noticeDetail',
		data
	})
}
// 运营历史
export function queryOperatingHistory(data) {
	return http({
		method: 'POST',
		url: 'DcOa/operateHistory',
		data
	})
}

//其他消息已读

export function queryMsgReadOther(data) {
	return http({
		method: 'POST',
		url: 'message/read',
		data
	})
}

//其他信息数量
export function queryMsgReadOtherNum(data) {
	return http({
		method: 'POST',
		url: 'message/num',
		data
	})
}

//公告全部已读
export function branchYueAll(data) {
	return http({
		method: 'POST',
		url: 'Pioneer/branchYueAll',
		data
	})
}

//其他消息全部已读
export function read_all(data) {
	return http({
		method: 'POST',
		url: 'message/read_all',
		data
	})
}

//登出
export function logout(data) {
	return http({
		method: 'POST',
		url: 'admin/v1/login/logout',
		data
	})
}
